import React from "react";

import { useEffect, /* useState */ } from 'react';
// import { Redirect } from 'react-router-dom';

import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

// import TermItem from "../components/onboarding/termItem";

import KCard from "../components/kCard";

// import DelayRedirect from "../components/delayRedirect";

class StepSummary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      summaryMessage:  props.getStore().summaryMessage,
      nextAction : props.getStore().nextAction,
    };
  }

  

  isValidated() {
    return false; // nowhere to go.
  }

 

  getStore = this.props.getStore;
  updateStore = this.props.updateStore;


/*
 <Box pt={3} pb={2}>
          <KCard>
            <label className="col-md-12 control-label">
              <Typography variant="h4">Part 1 Completed</Typography>
              <div className="your-class mt-3"></div>
            </label>
            <div className="container">{this.state.summaryMessage}</div>            
            <Box pb={2}></Box>
          </KCard>
        </Box>*/



  render() {
    const { nextAction } = this.state;

    return (
      <div className="step step3">
       <Box mt={3}></Box>        

        { (this.state.summaryMessage && !nextAction) && 
          <div className="container">{this.state.summaryMessage}</div>     
        }

        <Box>         
          {nextAction.messages.map((c, index) => (
              <MessageBlock key={index.toString()} block={c} />
          ))}
        </Box>
        <div>
          { nextAction.navigate &&
            <DelayRedirect delay={nextAction.navigate.delay} url = {nextAction.navigate.url} />
          }
        </div>
      </div>  
    );
  }
}

/*
   <div className="list-group text-left">
              {this.state.nextAction.messages.map((c, index) => (
                  <MessageBlock key={index.toString()} block={c} />
              ))}

            </div>*/

export default StepSummary;


// <DelayRedirect delay={5000} url = {'https://centersignup.com'}></RedirectExample>
function DelayRedirect(props) {
  useEffect(() => {
    const timeout = setTimeout(() => {
      // 👇️ redirects to an external URL
      window.location.replace(props.url);
    }, props.delay);

    return () => clearTimeout(timeout);
  }, [props.delay, props.url]);

  // return <>Will redirect in {props.delay/1000} seconds...</>;
  return <>&nbsp;</>;
}

function MessageBlock(props) {
  const { block } = props;
  return (
    <KCard>
      <label className="col-md-12 control-label">
        <Typography variant="h4">{block.title}</Typography>
        <div className="your-class mt-3"></div>
      </label>
      {block.lineItems.map((c, index) => (
              <MessageLine c key={index.toString()} text={c} />
      ))}
    <Box pb={2}></Box>
  </KCard>
  );
}


function MessageLine(props) {
  return (
    <RenderHTML text={props.text}></RenderHTML>
  );
}

const RenderHTML = (props) => (
  <Box m={2}>
    <div className="d-flex justify-content-center align-items-center" dangerouslySetInnerHTML={{ __html: props.text }}></div>
  </Box>
)